<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
      <li class="breadcrumb-item"><a routerLink="/corporate/addon-catalog-list">Add-on Catalog</a></li>
      <li class="breadcrumb-item active" aria-current="page">Edit Add-on Catalog</li>
    </ol>
  </nav>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-8">
      <form class="form-horizontal" [formGroup]="updateForm">
        <div class="card">
          <div class="card-body">
            <div class="form-group" *ngIf="customer_id==0">
              <label>Company Name</label>
              <input type="text" class="form-control" [value]="companyName || selectedCompany" readonly>
            </div>
            <div class="form-group">
              <label>Add-on Name</label>
              <input type="text" class="form-control" formControlName="bundle_name">
            </div>
            <div class="form-group">
              <label>Monthly Price <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="monthly_price" min="0" step="0.01"
                [ngClass]="{ 'is-invalid': submitted && f.monthly_price.errors }">
              <div *ngIf="submitted && f.monthly_price.errors" class="invalid-feedback">
                <div *ngIf="f.monthly_price.errors.required">Monthly price is required</div>
                <div *ngIf="f.monthly_price.errors.min">Monthly price must be 0 or greater</div>
              </div>
            </div>
            <div class="form-group">
              <label>Yearly Price <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="yearly_price" min="0" step="0.01"
                [ngClass]="{ 'is-invalid': submitted && f.yearly_price.errors }">
              <div *ngIf="submitted && f.yearly_price.errors" class="invalid-feedback">
                <div *ngIf="f.yearly_price.errors.required">Yearly price is required</div>
                <div *ngIf="f.yearly_price.errors.min">Yearly price must be 0 or greater</div>
              </div>
            </div>
            <div class="form-group">
              <label>Credits per $1 <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="credits_per_dollar" min="0" step="1"
                [ngClass]="{ 'is-invalid': submitted && f.credits_per_dollar.errors }">
              <div *ngIf="submitted && f.credits_per_dollar.errors" class="invalid-feedback">
                <div *ngIf="f.credits_per_dollar.errors.required">Credits per $1 is required</div>
                <div *ngIf="f.credits_per_dollar.errors.min">Credits per $1 must be 0 or greater</div>
              </div>
            </div>
            <div class="form-group">
              <label>Sort Order</label>
              <input type="number" class="form-control" formControlName="addon_sort">
            </div>
            <div class="form-group">
              <label>Sellable</label>
              <div>
                <label class="custmCheck">
                  <input type="checkbox" formControlName="is_addon_sellable">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <label>Who may buy</label>
              <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <th>Plan</th>
                  <th width="90" style="text-align:center">Allow</th>
                </tr>
                <tr>
                  <td>Basic</td>
                  <td align="center">
                    <label class="custmCheck">
                      <input type="checkbox" formControlName="allow_basic">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>Professional</td>
                  <td align="center">
                    <label class="custmCheck">
                      <input type="checkbox" formControlName="allow_professional">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <button type="button" class="custbtn mb-1" (click)="goCancel()">Cancel</button>
              <button type="button" class="btn btn-round btn-margo-action" (click)="updateAddonData()">Save</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
